import React, { useContext } from "react";

import Modal from "../UI/Modal";
import CartItem from "./CartItem";
import CartContext from "../../store/Cart-context";

import styles from "./Cart.module.css";

function Cart(props) {
  const cartCtx = useContext(CartContext);

  const AddItem = (item) => cartCtx.addItem({ ...item, amount: 1 });
  const removeItem = (id) => cartCtx.removeItem(id);

  const cartItems = (
    <ul className={styles["cart-items"]}>
      {cartCtx.items.map((item) => (
        <CartItem
          key={item.id}
          name={item.name}
          price={item.price}
          amount={item.amount}
          onAdd={AddItem.bind(null, item)}
          onRemove={removeItem.bind(null, item.id)}
        ></CartItem>
      ))}
    </ul>
  );
  return (
    <Modal hideCart={props.hideCart}>
      {cartItems}
      <div className={styles.total}>
        <span>Total Amount</span>
        <span>${cartCtx.totalAmount.toFixed(2)}</span>
      </div>
      <div className={styles.actions}>
        <button onClick={props.hideCart} className={styles["button--alt"]}>
          Close
        </button>
        {cartCtx.items.length > 0 && (
          <button className={styles.button}>Order</button>
        )}
      </div>
    </Modal>
  );
}

export default Cart;
